import citizensService from '@/services/CitizensService';

const citizen = {
  state: {
    citizenList: [],
  },
  getters: {
    citizens(state) {
      return state.citizenList;
    },
  },
  mutations: {
    SET_CITIZENS(state, payload) {
      state.citizenList = [...payload];
    },
  },
  actions: {
    getCitizens({ commit }) {
      citizensService.getCitizens()
        .then((response) => {
          commit('SET_CITIZENS', response.data);
        });
    },
  },
};

export default citizen;



// WEBPACK FOOTER //
// ./src/vuex/setting/citizens.js